import BaseResource from './index'

export default class UnionAdminLocalResource extends BaseResource {
    static endpoint = '/oasis/restv3/admin/unionLocals'
}
